import BaseService from './base_service'
import ListingService from './listing_service'

class ListingPaymentSettingsService extends BaseService {
  constructor (options = {}) {
    super(options)
    this.listingService = new ListingService(options)
  }

  static fetch (options) {
    const instance = new ListingPaymentSettingsService(options)
    return instance.fetch()
  }

  get apiUrl () {
    return new URL(`${this.serviceName}/`, this.listingService.apiUrl)
  }

  get serviceName () {
    return 'payment_settings'
  }
}

export default ListingPaymentSettingsService
